import React from "react";
import * as R from "ramda";
import { QuestionOutlined } from "@ant-design/icons";
import {
  message,
  Row,
  Col,
  Input,
  Button,
  notification,
  Radio,
  Select,
} from "antd";
import { Form } from "@ant-design/compatible";
import TextArea from "antd/lib/input/TextArea";
import { connect } from "react-redux";
import { startAddCheck } from "../actions/checks";
import { startSetLabelsData } from "../actions/auth";
import {
  formatPeriodRev,
  formatUrl,
  filterByName,
  formatProbersOptions,
  mergeAll,
  trimNum,
} from "./functions/checkFormFuncs";
import {
  protocolOptions,
  apdexOptions,
  periodOptions,
  httpMethodOptions,
  dnsQueryTypeOptions,
} from "./consts/formOptions";
import {
  checkProbersViolation,
  checkProtocolViolation,
  checkMethodViolation,
} from "../utils/checkActivePlanViolations";
import JsonInput from "./JsonInput";
import SelectDD from "./SelectDD";
import PopUp from "./PopUp";
import PlansPopUp from "./PlansPopUp";
import { formatPeriod } from "./functions/checkFormFuncs";
import HelpCenter from "./HelpCneter";
import Logo from "../assets/images/up-logo.svg";
import "../styles/components/check-form.scss";

const { Option } = Select;
class AddMonitor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      url: "",
      host: "",
      alias: "",
      period: "5 min",
      apdex: "0.5 sec",
      protocol_type: "HTTP(S)",
      http_method: "GET",
      probers: ["Sindad", "Hetzner", "ParsOnline (poonak)"],
      alert: [],
      http_headers: [{}],
      labels: [],
      isPlansOpen: false,
      showNotification: false,
      periodOptions: periodOptions,
      proberOptions: this.props.probers,
      visible: false,
      componentName: "apdex",
      is_enabled: true,
      dns_query_type: "A",
      dns_query_name: "",
    };
  }

  onMonitoringChanged = () => {
    this.setState({ is_enabled: !this.state.is_enabled });
  };

  showDrawer = (componentName) => {
    this.setState({
      visible: true,
      componentName: componentName,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onChange = (e) => {
    const val = e.target.value;
    const name = e.target.name;
    this.setState((prevState) => ({ [name]: val, host: prevState.url }));
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.sendData();
  };

  formatData = () => {
    const protocol = this.state.protocol_type;
    const isBaseProtocol = protocol === "HTTP(S)";
    const isDns = protocol === "DNS";

    const propIsNotEmpty = R.propSatisfies(R.complement(R.isEmpty));
    const isValid = R.allPass([
      propIsNotEmpty("url"),
      propIsNotEmpty("period"),
      propIsNotEmpty("apdex"),
      propIsNotEmpty("probers"),
    ]);

    if (!isValid(this.state)) {
      message.warning("Please fill all fields.");
      return;
    }

    const transformations = {
      url: formatUrl(R.__, protocol),
      host: formatUrl(R.__, protocol),
      period: formatPeriodRev,
      apdex: trimNum(R.__, 0, 4),
      http_headers: mergeAll,
    };
    const formatData = R.evolve(transformations);
    let monitor = formatData(this.state);

    const filterData = (receiver) =>
      R.includes(R.prop("value", receiver), this.state.alert);
    const formatAlertData = (value) =>
      R.map(R.prop("value"), R.filter(filterData, value));
    const formatAlerts = R.mapObjIndexed(formatAlertData);

    const probers = filterByName(this.props.probers, this.state.probers);
    const alerts = formatAlerts(this.props.alerts);
    monitor = R.assoc("probers", probers, monitor);
    monitor = R.assoc("alert", alerts, monitor);

    const dnsKeys = isDns
      ? ["http_headers", "http_method"]
      : ["dns_query_name", "dns_query_type"];
    let keysToOmitByProtocol = isBaseProtocol ? ["host"] : ["url"]; // TODO: rewrite with ramda
    keysToOmitByProtocol = R.concat(keysToOmitByProtocol, [
      "isPlansOpen",
      "showNotification",
      "periodOptions",
      "visible",
      "componentName",
      ...dnsKeys,
    ]);

    monitor = R.omit(keysToOmitByProtocol, monitor);

    const labels = this.props.labels;
    this.state.labels.forEach((el) => {
      if (!labels.includes(el)) {
        labels.push(el);
        this.props.startSetLabelsData(labels);
      }
    });

    this.props.startAddCheck(monitor);
    this.props.closePopUp();
  };

  sendData = () => {
    this.setState(
      (prevState) => ({
        host: prevState.url,
      }),
      this.formatData
    );
  };

  headerAdd = () => {
    this.setState((prevState) => {
      const temp = prevState.http_headers;
      temp.push({});
      return {
        http_headers: temp,
      };
    });
  };

  headerRemove = (index) => {
    this.setState((prevState) => {
      const temp = prevState.http_headers;
      temp.splice(index, 1);
      return {
        http_headers: temp,
      };
    });
  };

  changeHeaderValue = (obj, index) => {
    this.setState((prevState) => {
      const temp = prevState.http_headers;
      temp.splice(index, 1, obj);
      return {
        http_headers: temp,
      };
    });
  };

  showNotif = (title, text) => {
    const btn = (
      <Button
        onClick={() => {
          notification.close();
          this.setState({ isPlansOpen: true });
        }}
        type="primary"
        size="small"
      >
        Upgrade Plan
      </Button>
    );
    notification.config({
      duration: 10,
      placement: "bottomLeft",
    });
    const args = {
      message: title,
      description: text,
      btn,
    };
    notification.warn(args);
  };

  checkPeriodSelection = (period, subscriptions) => {
    let intPeriod = period;
    if (period.includes("min")) {
      intPeriod = parseInt(period.replace(/\D+/g, "")) * 60;
    } else if (period.includes("sec")) {
      intPeriod = parseInt(period.replace(/\D+/g, ""));
    }
    if (intPeriod < subscriptions.MINIMUM_MONITOR_PERIOD) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        `You can't select fewer than ${formatPeriod(
          subscriptions.MINIMUM_MONITOR_PERIOD
        )}`
      );
      this.getPeriodOptions(true);
      return false;
    }
    return true;
  };

  checkProberSelection = (prober, subscriptions, dataObj) => {
    const activePlanProbers = R.prop("PROBERS", subscriptions);
    let isViolated = false;
    if (activePlanProbers) {
      const selectableProbers = R.map(
        R.prop("value"),
        R.filter(
          (el) => R.includes(R.prop("id", el), activePlanProbers),
          R.flatten(R.values(dataObj))
        )
      );
      isViolated = checkProbersViolation(prober, selectableProbers);
    }

    if (isViolated) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        "Enabled probers can only be selected."
      );
      this.getProberOptions(true);
      return false;
    }

    return true;
  };

  checkProtocolViolation = (protocol, subscriptions) => {
    const activePlanProtocols = R.keys(subscriptions.PROTOCOL);
    const swapHttpWithHttps = R.map(
      (el) => (el === "HTTP" ? "HTTP(S)" : el),
      activePlanProtocols
    );
    const isViolated = checkProtocolViolation(protocol, swapHttpWithHttps);
    if (isViolated) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        "Enabled protocols can only be selected."
      );
      return false;
    }
    return true;
  };

  checkMethodViolation = (method, subscriptions) => {
    const activePlanMethods = R.path(
      ["PROTOCOL", "HTTP", "AVAILABLE_METHODS"],
      subscriptions
    );
    const isViolated = checkMethodViolation(method, activePlanMethods);
    if (isViolated) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        "Enabled methods can only be selected."
      );
      return false;
    }
    return true;
  };

  openPlans = () => {
    this.setState({
      isPlansOpen: true,
    });
  };

  closePlans = () => {
    this.setState({
      isPlansOpen: false,
    });
  };

  getPeriodOptions(mustDisable) {
    const checkLimit = (period) => {
      let intPeriod = period.value;
      if (period.value.includes("sec")) {
        intPeriod = parseInt(period.value.replace(/\D+/g, ""));
        if (intPeriod < this.props.subscriptions.MINIMUM_MONITOR_PERIOD) {
          period["disabled"] = true;
        }
      } else if (period.value.includes("min")) {
        intPeriod = parseInt(period.value.replace(/\D+/g, "")) * 60;
        if (intPeriod < this.props.subscriptions.MINIMUM_MONITOR_PERIOD) {
          period["disabled"] = true;
        }
      }
      return period;
    };

    if (this.state.showNotification || mustDisable) {
      let newPeriodOptions = R.clone(periodOptions);
      R.map(checkLimit, newPeriodOptions);
      this.setState({ periodOptions: newPeriodOptions });
    } else {
      this.setState({ periodOptions: periodOptions });
    }
  }

  getProberOptions(mustDisable) {
    const checkLimit = (prober) => {
      let isLimit = false;
      for (var id of this.props.subscriptions.PROBERS) {
        if (prober.id !== id) {
          isLimit = true;
        } else {
          isLimit = false;
          break;
        }
      }
      if (isLimit) {
        prober["disabled"] = true;
      }
      return prober;
    };

    if (this.state.showNotification || mustDisable) {
      let newProberOptions = R.clone(this.props.probers);
      R.map(checkLimit, newProberOptions);
      this.setState({ proberOptions: newProberOptions });
    } else {
      this.setState({ proberOptions: this.props.probers });
    }
  }

  onBodyChange = (e) => {
    const value = e.target.value;
    this.setState({ http_body: value });
  };

  handleChange = (labels) => {
    this.setState({ labels });
  };

  render() {
    const hasGroup = this.props.subscriptions
      ? R.has("MONITOR_GROUP", this.props.subscriptions)
      : false;
    const protocol = this.state.protocol_type;
    const isMobile = window.innerWidth < 576;
    const isBaseProtocol = protocol === "HTTP(S)";
    const isDns = protocol === "DNS";
    const targetPlaceholder =
      protocol === "TCP"
        ? "192.34.24.65:22"
        : protocol === "ICMP"
        ? "192.75.11.13"
        : protocol === "DNS"
        ? "8.8.8.8"
        : "http://www.website.com";
    return (
      <div className="check-form-body">
        <div className="logo-wrapper">
          <img src={Logo} alt="logo" />
        </div>
        <Form className="check-form" onSubmit={this.onSubmit}>
          <Row gutter={32} className="text-input">
            <Col span={24}>
              <div className="check-form__title">
                <h2>New Monitor</h2>
                <p>Enter your details below</p>
              </div>
            </Col>
            <Col span={24}>
              <Row gutter={32}>
                <Col
                  xxl={isBaseProtocol ? 20 : 24}
                  xl={isBaseProtocol ? 20 : 24}
                  lg={isBaseProtocol ? 20 : 24}
                  md={isBaseProtocol ? 20 : 24}
                  sm={24}
                  xs={24}
                >
                  <label htmlFor="url">Address</label>
                  <SelectDD
                    data={protocolOptions}
                    value={this.state.protocol_type}
                    onSelect={(protocol_type) =>
                      this.setState({ protocol_type })
                    }
                    style={{ width: "90px", display: "inline-block" }}
                    checkAuthority={this.checkProtocolViolation}
                    subscriptions={this.props.subscriptions}
                  />
                  <Input
                    type="text"
                    name="url"
                    id="url"
                    placeholder={targetPlaceholder}
                    autoFocus
                    value={this.state.url}
                    onChange={this.onChange}
                    className="address-input"
                  />
                </Col>
                {isBaseProtocol && (
                  <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
                    <label htmlFor="method">Method</label>
                    <SelectDD
                      name="method"
                      id="method"
                      value={this.state.http_method}
                      data={httpMethodOptions}
                      onSelect={(http_method) => this.setState({ http_method })}
                      style={{ width: "100%" }}
                      checkAuthority={this.checkMethodViolation}
                      subscriptions={this.props.subscriptions}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={32}>
                <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                  <label htmlFor="alias">Name (optional)</label>
                  <Input
                    type="text"
                    id="alias"
                    name="alias"
                    placeholder="Website"
                    value={this.state.alias}
                    onChange={this.onChange}
                  />
                </Col>

                <Col xxl={6} xl={6} md={6} sm={12} xs={12}>
                  <label htmlFor="time_interval">Time interval</label>
                  <SelectDD
                    id="time_interval"
                    name="time_interval"
                    data={this.state.periodOptions}
                    value={this.state.period}
                    onSelect={(period) => {
                      this.setState({ period });
                    }}
                    checkAuthority={this.checkPeriodSelection}
                    subscriptions={this.props.subscriptions}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xxl={6} xl={6} md={6} sm={12} xs={12}>
                  <label htmlFor="apdex">
                    Expected time
                    <Button
                      name="apdex"
                      id="apdex"
                      shape="circle"
                      icon={<QuestionOutlined />}
                      size="small"
                      onClick={() => this.showDrawer("apdex")}
                    />
                  </label>
                  <SelectDD
                    data={apdexOptions}
                    value={this.state.apdex}
                    onSelect={(apdex) => this.setState({ apdex })}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>
            </Col>
            {isDns && (
              <Col span={24}>
                <Row gutter={32}>
                  <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                    <label htmlFor="dns_query_name">DNS query value</label>
                    <Input
                      type="text"
                      id="dns_query_name"
                      name="dns_query_name"
                      placeholder="google.com"
                      value={this.state.dns_query_name}
                      onChange={this.onChange}
                    />
                  </Col>

                  <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                    <label htmlFor="dns_query_type">DNS query type</label>
                    <SelectDD
                      data={dnsQueryTypeOptions}
                      id="dns_query_type"
                      name="dns_query_type"
                      value={this.state.dns_query_type}
                      onSelect={(dns_query_type) => {
                        this.setState({ dns_query_type });
                      }}
                      style={{ width: "100%" }}
                    />
                  </Col>
                </Row>
              </Col>
            )}
            <Col span={24}>
              <Row gutter={32}>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <label htmlFor="probers">Probers (Datacenters)</label>
                  <SelectDD
                    name="probers"
                    id="probers"
                    mode="multiple"
                    value={this.state.probers}
                    dataObj={formatProbersOptions(this.state.proberOptions)}
                    onSelect={(probers) => this.setState({ probers })}
                    checkAuthority={this.checkProberSelection}
                    subscriptions={this.props.subscriptions}
                    style={{ width: "100%" }}
                    maxTagCount={3}
                  />
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <label htmlFor="alerts">Alerts</label>
                  <SelectDD
                    name="alerts"
                    id="alerts"
                    mode="multiple"
                    value={this.state.alert}
                    dataObj={this.props.alerts}
                    onSelect={(alert) => this.setState({ alert })}
                    style={{ width: "100%" }}
                    maxTagCount={3}
                    extraButton="Add New Alert Channel"
                    extraButtonAction={() => this.showDrawer("alerts")}
                  />
                </Col>
              </Row>
            </Col>
            {isBaseProtocol && (
              <Col span={24}>
                <Row gutter={32}>
                  <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                    <label htmlFor="header">Header (optional)</label>
                    <div className="h-100">
                      {this.state.http_headers &&
                        this.state.http_headers.map((el, index) => {
                          return (
                            <JsonInput
                              id="header"
                              name="header"
                              index={index}
                              remove={this.headerRemove}
                              headKey={Object.keys(el)[0]}
                              headValue={el[Object.keys(el)[0]]}
                              changeJsonValue={this.changeHeaderValue}
                              isLast={
                                this.state.http_headers.length - 1 === index
                              }
                              add={this.headerAdd}
                            />
                          );
                        })}
                    </div>
                  </Col>
                  {(this.state.http_method === "PUT" ||
                    this.state.http_method === "POST") && (
                    <Col span={12}>
                      <label htmlFor="body">Body</label>
                      <div>
                        <TextArea
                          id="body"
                          name="body"
                          value={this.state.http_body}
                          onChange={this.onBodyChange}
                          placeholder="Your request body"
                          autosize={{ minRows: 2, maxRows: 20 }}
                        />
                      </div>
                    </Col>
                  )}
                  <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                    <label htmlFor="monitoring">Monitoring</label>
                    <div>
                      <Radio.Group
                        value={this.state.is_enabled ? "enable" : "disable"}
                        buttonStyle="solid"
                        onChange={this.onMonitoringChanged}
                      >
                        <Radio.Button value="enable">Enable</Radio.Button>
                        <Radio.Button value="disable">Disable</Radio.Button>
                      </Radio.Group>
                    </div>
                  </Col>
                </Row>
              </Col>
            )}
            {hasGroup && (
              <Col span={24}>
                <Row>
                  <Col span={12}>
                    <label htmlFor="groups">Groups</label>
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Groups"
                      onChange={this.handleChange}
                      value={this.state.labels}
                    >
                      {this.props.labels.map((el) => (
                        <Option key={el}>{el}</Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
          <Col span={24}>
            <div className="check-form__btns">
              <Button
                type="button"
                shape="round"
                size="large"
                onClick={() => {
                  this.props.closePopUp();
                  notification.close("1");
                }}
              >
                Cancel
              </Button>
              <Button
                className="save"
                shape="round"
                loading={this.props.fetchInProgress}
                size="large"
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
            </div>
          </Col>
        </Form>
        {this.state.isPlansOpen && (
          <PopUp
            closePopUp={this.closePlans}
            closeOnOutClick={false}
            style={{ zIndex: 50 }}
          >
            <PlansPopUp />
          </PopUp>
        )}
        <HelpCenter
          width={isMobile ? "100%" : 475}
          placement="left"
          closable={true}
          onClose={this.onClose}
          visible={this.state.visible}
          name={this.state.componentName}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    probers: state.probers,
    alerts: state.auth.alert_channels,
    labels: state.auth.labels,
    fetchInProgress: state.fetchInProgress,
    subscriptions: state.plans.subscriptions
      ? state.plans.subscriptions[0].subscription_plan.specifications
      : undefined,
    plan_name: state.plans.subscriptions
      ? state.plans.subscriptions[0].subscription_plan.name
      : undefined,
  };
};

const mapDispatchToProps = (dispatch) => ({
  startAddCheck: (check) => dispatch(startAddCheck(check)),
  startSetLabelsData: (labels) => dispatch(startSetLabelsData(labels)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMonitor);
